import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createClass from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import axios from "axios";
export var ServerGQLClientError = /*#__PURE__*/_createClass(function ServerGQLClientError(_ref) {
  var graphQLErrors = _ref.graphQLErrors,
      error = _ref.error,
      data = _ref.data;

  _classCallCheck(this, ServerGQLClientError);

  _defineProperty(this, "graphQLErrors", void 0);

  _defineProperty(this, "error", void 0);

  _defineProperty(this, "data", void 0);

  this.graphQLErrors = graphQLErrors || [];
  this.error = error;
  this.data = data || null;
});
export var ServerGQLClient = /*#__PURE__*/function () {
  function ServerGQLClient(_ref2) {
    var uri = _ref2.uri;

    _classCallCheck(this, ServerGQLClient);

    _defineProperty(this, "uri", void 0);

    this.uri = uri;
  }

  _createClass(ServerGQLClient, [{
    key: "query",
    value: function () {
      var _query2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
        var _query$loc;

        var _query, variables, headers, queryBody, response, responseAsErrorPayload;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _query = _ref3.query, variables = _ref3.variables, headers = _ref3.headers;

                if (this.uri) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", new ServerGQLClientError({
                  error: {
                    message: "ServerGQLClient: uri is not defined"
                  }
                }));

              case 3:
                queryBody = (_query$loc = _query.loc) === null || _query$loc === void 0 ? void 0 : _query$loc.source.body;

                if (queryBody) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", new ServerGQLClientError({
                  error: {
                    message: "Make sure the provided query is valid"
                  }
                }));

              case 6:
                _context.prev = 6;
                _context.next = 9;
                return axios.post(this.uri, {
                  query: queryBody,
                  variables: variables
                }, {
                  headers: headers
                });

              case 9:
                response = _context.sent;
                // If GraphQL error, we status code will still be 200 and hence we need to check for errors manually
                responseAsErrorPayload = response.data;

                if (!(responseAsErrorPayload !== null && responseAsErrorPayload !== void 0 && responseAsErrorPayload.errors)) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", new ServerGQLClientError({
                  graphQLErrors: responseAsErrorPayload.errors,
                  data: responseAsErrorPayload === null || responseAsErrorPayload === void 0 ? void 0 : responseAsErrorPayload.data
                }));

              case 13:
                return _context.abrupt("return", response.data);

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](6);
                return _context.abrupt("return", new ServerGQLClientError({
                  graphQLErrors: _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.errors,
                  data: _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.data,
                  error: {
                    message: _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message
                  }
                }));

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 16]]);
      }));

      function query(_x) {
        return _query2.apply(this, arguments);
      }

      return query;
    }()
  }]);

  return ServerGQLClient;
}();